import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=33908226&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=33908226&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33908226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33908226')) {
      api.createRecord('33908226', component.options)
    } else {
      api.reload('33908226', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=33908226&scoped=true", function () {
      api.rerender('33908226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/components/Product.vue"
export default component.exports